import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './BusinessHelpCenter.css';
import BusinessSidebar from "../../BusinessSidebar";
import Header from "../../BusinessHeaderAfterLogin";
import Footer from "../../BusinessFooterAfterLogin";
import loader from '../../../assests/loader.gif';
import API from '../../../Utils/Api';
import Accordion from 'react-bootstrap/Accordion';
import Image from 'react-bootstrap/Image';
import { Link,useNavigate } from 'react-router-dom';

const BusinessHelpCenter = () => {
    const navigate = useNavigate();
    const [loading,setLoading] = useState(false);
    const [help, setHelp] = useState([]);

    useEffect(() => {
        document.title = `Business Privacy | Local Bells`;
        document.getElementById('bodywrap').className = 'busiprivacy';

        /* Start get help */
            API.post('get_faq')
                .then(response => {
                    setLoading(false);
                if(response.data.status === false){
                    
                }else{
                  setHelp(response.data.data);
                }                  
            }).catch(error => {
                setLoading(false); 
            });  
        /* End get help */

    }, []);
   
// State to toggle sidebar visibility
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);

  // Function to toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarVisible((prev) => !prev);
  };

    return (
        <>
            <section className="main-cont-box">
                <Container>
                    <Row>
                        <BusinessSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible}/>
                        <Col md={12} lg={9} xl={9} xxl={10} className='main-cont-box-right'>
                            <Header toggleSidebar={toggleSidebar} />
                            <div className='nei-cont'>
                                <div className='white-box acc-box'>
                                    <Row>
                                        <Col xs={12}>
                                        <div className="d-flex align-items-start justify-content-between gap-3">
                                                <h3>General Questions</h3>
                                                <Link to="#" onClick={() => navigate(-1)} className='cross-up'>
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/cross.webp'} className="img-fluid crosy" alt="wp" />
                                                </Link>
                                            </div>
                                            
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12}>
                                            <Accordion defaultActiveKey="0">
                                               {help && help.map((val, index) => {
                                                    return (
                                                        <Accordion.Item eventKey={index.toString()} key={index}>
                                                            <Accordion.Header>{val.title}</Accordion.Header>
                                                            <Accordion.Body>
                                                                {val.description}
                                                            </Accordion.Body>
                                                        </Accordion.Item>
                                                    );
                                                })}
                                                
                                            </Accordion>
                                        </Col>
                                    </Row>
                                </div>
                                   <div className='footer-org footer'>
                                    <Footer />                                
                                </div>                                
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            
             {loading && (
               <div className="loadingClass">
                <img src={loader} alt="loader"/>
              </div>
            )}   
        </>
    )
}

export default BusinessHelpCenter;


